import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'
class XbOrder {
  // 获取前台订单列表
  getXBOrderList(options) {
    let url = '/api/xb/order/search?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据orderCode获取订单详情
  getOrderDetailByOrderCode(orderCode) {
    const url = `/api/xb/order/info/detail?orderCode=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据orderCode获取物流详情
  getLogisticsByOrderCode(orderCode) {
    const url = `/api/xb/order/express/detail?code=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据orderCode获取退货单详情
  getReturnOrderDetailByOrderCode(orderCode) {
    const url = `/api/xb/refund/page?orderCode=${orderCode}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据orderCode取消订单
  cancelOrderByOrderCode(data) {
    const url = `/api/xb/order/cancel`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据orderCode确认收货
  confirmReceiveByOrderCode(data) {
    const url = `/api/xb/order/received`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取确认支付页面支付详情
  getConfirmPayDetail(options) {
    let url = '/api/xb/order/pay/method/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 根据orderCode调用支付宝支付
  aliPayWithOrderCode(options) {
    let url = `/api/pay/ali?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 根据orderCode调用微信支付
  weChatPay(options) {
    let url = `/api/pay/wx/native?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 线下支付
  offlinePay(data) {
    const url = `/api/pay/offline`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 货到付款
  deliveryPay(data) {
    const url = `/api/pay/cod`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 农行支付
  agriculturalBankPay(orderCode) {
    const url = `/api/xb/order/pay?orderCode=${orderCode}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 再来一单
  postMoreOrder(data) {
    const url = `/api/xb/order/one/more`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 确认收款
  postConfirmCollection(data) {
    const url = `/api/xb/order/confirm/refund`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XbOrder
